// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-container {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  overflow: hidden;
  padding: 16px;
  background-color: #0f172a;
}

.results-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
}

.results-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #f1f5f9;
}

.results-controls {
  display: flex;
  gap: 12px;
  align-items: center;
}

.filter-group {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background-color: #1e293b;
  border: 1px solid #334155;
  border-radius: 6px;
  color: #cbd5e1;
}

.filter-group svg {
  flex-shrink: 0;
  color: #94a3b8;
}

.type-filter {
  background: none;
  border: none;
  color: #e2e8f0;
  font-size: 13px;
  outline: none;
  cursor: pointer;
  min-width: 120px;
}

.type-filter option {
  background-color: #1e293b;
  color: #e2e8f0;
}

.clear-filter {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  transition: color 0.2s;
}

.clear-filter:hover {
  color: #cbd5e1;
}

.refresh-button {
  padding: 8px 12px;
  background-color: #3b82f6;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.refresh-button:hover:not(:disabled) {
  background-color: #2563eb;
}

.refresh-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.error-message {
  padding: 12px;
  background-color: #7f1d1d;
  border: 1px solid #dc2626;
  border-radius: 4px;
  color: #fecaca;
  font-size: 14px;
}

.loading {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  color: #94a3b8;
  font-size: 14px;
}

.no-results {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  color: #64748b;
  font-size: 14px;
  font-style: italic;
}

.results-table-wrapper {
  flex: 1 1;
  overflow: auto;
  border: 1px solid #334155;
  border-radius: 6px;
  background-color: #1e293b;
}

.penalty-count-badge {
  display: inline-block;
  margin-left: 8px;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: rgba(239, 68, 68, 0.15);
  color: #fecaca;
  font-size: 12px;
  font-weight: 600;
}

.results-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.results-table thead {
  background-color: #0f172a;
  position: sticky;
  top: 0;
  z-index: 10;
}

.results-table th {
  padding: 12px;
  text-align: left;
  font-weight: 600;
  color: #cbd5e1;
  border-bottom: 1px solid #334155;
  -webkit-user-select: none;
          user-select: none;
}

.results-table tbody tr {
  border-bottom: 1px solid #334155;
  transition: background-color 0.2s;
}

.results-table tbody tr:hover {
  background-color: #334155;
}

.results-table td {
  padding: 12px;
  color: #e2e8f0;
}

.col-date {
  width: 200px;
  font-family: 'Courier New', monospace;
  color: #cbd5e1;
}

.col-type {
  width: 100px;
}

.col-size {
  width: 80px;
  text-align: right;
  color: #94a3b8;
}

.col-actions {
  width: 280px;
  text-align: right;
}

.type-badge {
  display: inline-block;
  padding: 4px 8px;
  border-radius: 4px;
  font-weight: 500;
  font-size: 12px;
}

.type-badge.type-practice {
  background-color: #dbeafe;
  color: #1e40af;
}

.type-badge.type-qualify {
  background-color: #fef3c7;
  color: #92400e;
}

.type-badge.type-warmup {
  background-color: #d1fae5;
  color: #065f46;
}

.type-badge.type-race {
  background-color: #fee2e2;
  color: #7f1d1d;
}

.results-container .view-button,
.results-container .download-button,
.results-container .delete-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: background-color 0.2s;
  white-space: nowrap;
  margin-left: 6px;
}

.results-container .delete-button {
  background-color: #dc2626;
  color: white;
}

.results-container .delete-button:hover:not(:disabled) {
  background-color: #b91c1c;
}

.results-container .view-button {
  background-color: #6366f1;
  color: white;
}

.results-container .view-button:hover:not(:disabled) {
  background-color: #4f46e5;
}

.results-container .download-button {
  background-color: #10b981;
  color: white;
}

.results-container .download-button:hover:not(:disabled) {
  background-color: #059669;
}

.results-container .view-button:disabled,
.results-container .download-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.view-button svg,
.download-button svg {
  flex-shrink: 0;
}

/* Scrollbar styling */
.results-table-wrapper::-webkit-scrollbar {
  height: 8px;
  width: 8px;
}

.results-table-wrapper::-webkit-scrollbar-track {
  background-color: #0f172a;
}

.results-table-wrapper::-webkit-scrollbar-thumb {
  background-color: #475569;
  border-radius: 4px;
}

.results-table-wrapper::-webkit-scrollbar-thumb:hover {
  background-color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/components/Results.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;EACP,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,MAAM;EACN,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".results-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n  height: 100%;\r\n  overflow: hidden;\r\n  padding: 16px;\r\n  background-color: #0f172a;\r\n}\r\n\r\n.results-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  gap: 16px;\r\n}\r\n\r\n.results-header h3 {\r\n  margin: 0;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #f1f5f9;\r\n}\r\n\r\n.results-controls {\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.filter-group {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  padding: 8px 12px;\r\n  background-color: #1e293b;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.filter-group svg {\r\n  flex-shrink: 0;\r\n  color: #94a3b8;\r\n}\r\n\r\n.type-filter {\r\n  background: none;\r\n  border: none;\r\n  color: #e2e8f0;\r\n  font-size: 13px;\r\n  outline: none;\r\n  cursor: pointer;\r\n  min-width: 120px;\r\n}\r\n\r\n.type-filter option {\r\n  background-color: #1e293b;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.clear-filter {\r\n  background: none;\r\n  border: none;\r\n  color: #94a3b8;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  transition: color 0.2s;\r\n}\r\n\r\n.clear-filter:hover {\r\n  color: #cbd5e1;\r\n}\r\n\r\n.refresh-button {\r\n  padding: 8px 12px;\r\n  background-color: #3b82f6;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.refresh-button:hover:not(:disabled) {\r\n  background-color: #2563eb;\r\n}\r\n\r\n.refresh-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.error-message {\r\n  padding: 12px;\r\n  background-color: #7f1d1d;\r\n  border: 1px solid #dc2626;\r\n  border-radius: 4px;\r\n  color: #fecaca;\r\n  font-size: 14px;\r\n}\r\n\r\n.loading {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n  color: #94a3b8;\r\n  font-size: 14px;\r\n}\r\n\r\n.no-results {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex: 1;\r\n  color: #64748b;\r\n  font-size: 14px;\r\n  font-style: italic;\r\n}\r\n\r\n.results-table-wrapper {\r\n  flex: 1;\r\n  overflow: auto;\r\n  border: 1px solid #334155;\r\n  border-radius: 6px;\r\n  background-color: #1e293b;\r\n}\r\n\r\n.penalty-count-badge {\r\n  display: inline-block;\r\n  margin-left: 8px;\r\n  padding: 2px 8px;\r\n  border-radius: 999px;\r\n  background-color: rgba(239, 68, 68, 0.15);\r\n  color: #fecaca;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.results-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  font-size: 13px;\r\n}\r\n\r\n.results-table thead {\r\n  background-color: #0f172a;\r\n  position: sticky;\r\n  top: 0;\r\n  z-index: 10;\r\n}\r\n\r\n.results-table th {\r\n  padding: 12px;\r\n  text-align: left;\r\n  font-weight: 600;\r\n  color: #cbd5e1;\r\n  border-bottom: 1px solid #334155;\r\n  user-select: none;\r\n}\r\n\r\n.results-table tbody tr {\r\n  border-bottom: 1px solid #334155;\r\n  transition: background-color 0.2s;\r\n}\r\n\r\n.results-table tbody tr:hover {\r\n  background-color: #334155;\r\n}\r\n\r\n.results-table td {\r\n  padding: 12px;\r\n  color: #e2e8f0;\r\n}\r\n\r\n.col-date {\r\n  width: 200px;\r\n  font-family: 'Courier New', monospace;\r\n  color: #cbd5e1;\r\n}\r\n\r\n.col-type {\r\n  width: 100px;\r\n}\r\n\r\n.col-size {\r\n  width: 80px;\r\n  text-align: right;\r\n  color: #94a3b8;\r\n}\r\n\r\n.col-actions {\r\n  width: 280px;\r\n  text-align: right;\r\n}\r\n\r\n.type-badge {\r\n  display: inline-block;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-weight: 500;\r\n  font-size: 12px;\r\n}\r\n\r\n.type-badge.type-practice {\r\n  background-color: #dbeafe;\r\n  color: #1e40af;\r\n}\r\n\r\n.type-badge.type-qualify {\r\n  background-color: #fef3c7;\r\n  color: #92400e;\r\n}\r\n\r\n.type-badge.type-warmup {\r\n  background-color: #d1fae5;\r\n  color: #065f46;\r\n}\r\n\r\n.type-badge.type-race {\r\n  background-color: #fee2e2;\r\n  color: #7f1d1d;\r\n}\r\n\r\n.results-container .view-button,\r\n.results-container .download-button,\r\n.results-container .delete-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 12px;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  transition: background-color 0.2s;\r\n  white-space: nowrap;\r\n  margin-left: 6px;\r\n}\r\n\r\n.results-container .delete-button {\r\n  background-color: #dc2626;\r\n  color: white;\r\n}\r\n\r\n.results-container .delete-button:hover:not(:disabled) {\r\n  background-color: #b91c1c;\r\n}\r\n\r\n.results-container .view-button {\r\n  background-color: #6366f1;\r\n  color: white;\r\n}\r\n\r\n.results-container .view-button:hover:not(:disabled) {\r\n  background-color: #4f46e5;\r\n}\r\n\r\n.results-container .download-button {\r\n  background-color: #10b981;\r\n  color: white;\r\n}\r\n\r\n.results-container .download-button:hover:not(:disabled) {\r\n  background-color: #059669;\r\n}\r\n\r\n.results-container .view-button:disabled,\r\n.results-container .download-button:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.view-button svg,\r\n.download-button svg {\r\n  flex-shrink: 0;\r\n}\r\n\r\n/* Scrollbar styling */\r\n.results-table-wrapper::-webkit-scrollbar {\r\n  height: 8px;\r\n  width: 8px;\r\n}\r\n\r\n.results-table-wrapper::-webkit-scrollbar-track {\r\n  background-color: #0f172a;\r\n}\r\n\r\n.results-table-wrapper::-webkit-scrollbar-thumb {\r\n  background-color: #475569;\r\n  border-radius: 4px;\r\n}\r\n\r\n.results-table-wrapper::-webkit-scrollbar-thumb:hover {\r\n  background-color: #64748b;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
